<template>
  <ValidationProvider v-slot="{ valid, errors }" ref="validator" :vid="vid" :name="$attrs.name" :rules="rules">
    <b-form-group :id="`input-group-${$attrs.name}`" v-bind="$attrs">
      <date-picker
        v-model="innerValue"
        lang="en"
        placeholder="Select date"
        :type="type"
        :value-type="valueFormat"
        :format="format"
        :minute-step="minute"
        :confirm="confirm"
        :state="errors[0] ? false : (valid ? true : null)"
      	:aria-describedby="`${$attrs.name}-live-feedback`"
      >
      </date-picker>
      <input v-show="false" v-model="innerValue" />
    	<b-form-invalid-feedback :id="`${$attrs.name}-live-feedback`">{{ errors[0] }}</b-form-invalid-feedback>
    </b-form-group>
  </ValidationProvider>
</template>


<script>
import { ValidationProvider } from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import formatDate from "../../utils/format-date";

export default {
  components: {
    ValidationProvider,
    DatePicker
  },
  props: {
    vid: {
      type: String,
      default: '',
    },
    rules: {
      type: [Object, String],
      default: '',
    },
    // must be included in props
    value: {
      type: null,
      default: '',
    },
    minute: {
      type: null,
      default: null,
    },
    confirm: {
      type: Boolean,
      default: false,
    },
    format: {
      type: String,
      default: 'MM/DD/YYYY',
    },
    valueFormat: {
      type: String,
      default: 'YYYY-MM-DD',
    },
    type: {
      type: String,
      default: 'date'
    }
  },
  data: () => ({
    innerValue: '',
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit('update-value', newVal)
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = formatDate(newVal, this.valueFormat)
    },
  },
  created() {
    if (this.value) {
      this.innerValue = formatDate(this.value, this.valueFormat)
    }
  },
}
</script>
